import React from 'react';

import GermanOneHourRegulations from './GermanOneHourRegulations/GermanOneHourRegulations';

const StaticMessages = () => <GermanOneHourRegulations />;

export default StaticMessages;
